import { generateInvoiceXML } from "../APIs/InvoicesAPI";

export async function openPDFtab(invoice_id) {
    const token = localStorage.getItem("accessToken")
    const tenant = localStorage.getItem("tenantId")
    const invoice_xml = await generateInvoiceXML(invoice_id, token, tenant)
    const html_template = generaHTMLFattura(invoice_xml)
    const blob = new Blob(
        [html_template],
        { type: 'text/html' }
    );

    const url = URL.createObjectURL(blob);

    window.open(url, '_blank');
}

export function generaHTMLFattura(xmlString) {

    const parser = new DOMParser();

    const xml =
        parser.parseFromString(xmlString, "text/xml");


    function get(tag) {
        return xml.getElementsByTagName(tag)[0]?.textContent || '';
    }

    function getFrom(node, tag) {
        return node?.getElementsByTagName(tag)[0]?.textContent || '';
    }

    function fmt2(value) {
        const n = parseFloat(value);
        return isNaN(n) ? value : n.toFixed(2);
    }

    function fiscalVatLabel(node) {
        const fiscalVatNode = node?.getElementsByTagName("IdFiscaleIVA")[0];
        const country = getFrom(fiscalVatNode, "IdPaese");
        const code = getFrom(fiscalVatNode, "IdCodice");

        if (!country && !code) return "-";
        return `${country}${code}`;
    }


    // DATI

    const cedente =
        xml.getElementsByTagName("CedentePrestatore")[0];

    const cliente =
        xml.getElementsByTagName("CessionarioCommittente")[0];

    const righe =
        xml.getElementsByTagName("DettaglioLinee");

    const riepiloghi =
        xml.getElementsByTagName("DatiRiepilogo");


    // RIGHE HTML

    let righeHTML = '';

    for (let riga of righe) {

        righeHTML += `
            <tr>

                <td>${getFrom(riga, "NumeroLinea")}</td>

                <td>${getFrom(riga, "Descrizione")}</td>

                <td>${getFrom(riga, "Quantita")}</td>

                <td>${getFrom(riga, "UnitaMisura")}</td>

                <td>${fmt2(getFrom(riga, "PrezzoUnitario"))} €</td>

                <td>-</td>

                <td>${fmt2(getFrom(riga, "PrezzoTotale"))} €</td>

                <td>${getFrom(riga, "AliquotaIVA")}%</td>

            </tr>
`;
    }

    let riepilogoIVAHTML = '';

    let totaleImponibile = 0;
    let totaleImposta = 0;

    console.log("riepiloghi", riepiloghi)
    for (let r of riepiloghi) {

        riepilogoIVAHTML += `
            <tr>
                <td>${getFrom(r, "AliquotaIVA")}%</td>
                <td>${getFrom(r, "Natura") || "-"}</td>
                <td>${getFrom(r, "RiferimentoNormativo") || "-"}</td>
                <td>${getFrom(r, "EsigibilitaIVA") || "-"}</td>
                <td>${getFrom(r, "ImponibileImporto")} €</td>
                <td>${getFrom(r, "Imposta")} €</td>
            </tr>
            `;
    
        console.log("getFrom(r, 'ImponibileImporto')",getFrom(r, "ImponibileImporto"))
        console.log("getFrom(r, 'Imposta')",getFrom(r, "Imposta"))
        
        totaleImponibile += Number(
            getFrom(r, "ImponibileImporto") || 0
        );

        totaleImposta += Number(
            getFrom(r, "Imposta") || 0
        );
    }

    return `
    <!DOCTYPE html>

    <html lang="it">

    <head>

        <meta charset="UTF-8">

        <title>Fattura Elettronica</title>

        <style>

            *{
                box-sizing:border-box;
                -webkit-print-color-adjust:exact;
                print-color-adjust:exact;
            }

            @page{
                margin:15mm;
            }

            body{
                margin:0;
                padding:30px;
                background:#e9e9e9;
                font-family:Arial, sans-serif;
                color:#333;
            }

            @media print{
                body{
                    background:white;
                    padding:0;
                }
                .invoice{
                    box-shadow:none;
                    max-width:100%;
                    padding:0;
                }
            }

            .invoice{

                max-width:1200px;
                margin:auto;

                background:white;

                padding:40px;

                box-shadow:0 0 10px rgba(0,0,0,0.1);
            }

            .top{

                display:flex;
                justify-content:space-between;
                align-items:flex-start;

                margin-bottom:30px;
            }

            .title{

                text-align:right;
            }

            .title h1{

                margin:0;
                font-size:42px;
                font-weight:bold;
            }

            .two-cols{

                display:grid;
                grid-template-columns:1fr 1fr;
                gap:20px;

                margin-bottom:30px;
            }

            .box{

                background:#f3f3f3;
                padding:20px;
            }

            .box h2{

                margin-top:0;
                font-size:22px;
            }

            table {
                width:100%;
                border-collapse:collapse;
            }

            table th{
                background:#ddd;
                padding:8px 6px;
                text-align:center;
                font-size:11px;
                line-height:1.2;
            }

            table td{
                padding:8px 6px;
                border-bottom:1px solid #ddd;
                font-size:11px;
                text-align:center;
            }

            table th,
            table td{
                overflow-wrap:break-word;
            }
            
            .section-title{

                margin-top:40px;
                margin-bottom:15px;

                font-size:28px;
                font-weight:bold;
            }

            .summary{
                gap:40px;
            }

            .summary > div:first-child{
                flex:3;
            }

            .summary > div:last-child{
                flex:1;
            }

            .totals{

                background:#f3f3f3;
                padding:20px;
            }

            .totals-row{
                display:flex;
                justify-content:space-between;
                align-items:center;
                gap:20px;
            }

            .totals-row span{
                white-space:nowrap;
            }

            .totals-row strong{
                white-space:nowrap;
            }

            .final-total{
                margin-top:20px;
                padding-top:20px;
                border-top:2px solid #ccc;

                display:flex;
                justify-content:space-between;
                align-items:flex-start;

                font-size:22px;
                font-weight:bold;
                gap:15px;
            }

            .final-total span{
                flex:1;
            }

            .final-total strong{
                white-space:nowrap;
                flex-shrink:0;
            }

            .muted{
                color:#666;
            }

            .small{
                font-size:13px;
            }
            
            .money {
                white-space: nowrap;
                text-align: right;
            }

            .summary,
            .regime-fiscale,
            .dati-aggiuntivi,
            .box {
                page-break-inside: avoid;
                break-inside: avoid;
            }
            
            .prodotti-table{
                table-layout:fixed;
            }

            .prodotti-table col.nr{
                width:6%;
            }

            .prodotti-table col.descrizione{
                width:28%;
            }

            .prodotti-table col.qta{
                width:8%;
            }

            .prodotti-table col.um{
                width:12%;
            }

            .prodotti-table col.prezzo{
                width:12%;
            }

            .prodotti-table col.sconto{
                width:12%;
            }

            .prodotti-table col.totale{
                width:12%;
            }

            .prodotti-table col.iva{
                width:10%;
            }
        </style>

    </head>

    <body>

        <div class="invoice">

            <div class="top">

                <div></div>

                <div class="title">

                    <h1>FATTURA</h1>

                    <div>
                        nr.
                        ${get("Numero")}
                    </div>

                    <div>
                        del
                        ${get("Data")}
                    </div>

                </div>

            </div>



            <div class="two-cols">

                <div class="box">

                    <h2>FORNITORE</h2>

                    <strong>
                        ${getFrom(cedente, "Denominazione")}
                    </strong>

                    <p>
                        P.IVA:
                        ${fiscalVatLabel(cedente)}
                    </p>

                    <p>
                        C.F:
                        ${getFrom(cedente, "CodiceFiscale")}
                    </p>

                    <p>
                        ${getFrom(cedente, "Indirizzo")}
                    </p>

                    <p>
                        ${getFrom(cedente, "CAP")}
                        -
                        ${getFrom(cedente, "Comune")}
                        (${getFrom(cedente, "Provincia")})
                    </p>

                    <p>
                        Telefono:
                        ${getFrom(cedente, "Telefono")}
                    </p>

                    <p>
                        ${getFrom(cedente, "Email")}
                    </p>

                </div>



                <div class="box">

                    <h2>CLIENTE</h2>

                    <strong>
                        ${getFrom(cliente, "Denominazione")}
                    </strong>

                    <p>
                        P.IVA:
                        ${fiscalVatLabel(cliente)}
                    </p>

                    <p>
                        ${getFrom(cliente, "Indirizzo")}
                        ${getFrom(cliente, "NumeroCivico")}
                    </p>

                    <p>
                        ${getFrom(cliente, "CAP")}
                        -
                        ${getFrom(cliente, "Comune")}
                        (${getFrom(cliente, "Provincia")})
                    </p>

                    <p>
                        Codice destinatario:
                        ${get("CodiceDestinatario")}
                    </p>

                </div>

            </div>


<div class="section-title">

    PRODOTTI E SERVIZI

</div>

<table class="prodotti-table">

    <colgroup>
        <col class="nr">
        <col class="descrizione">
        <col class="qta">
        <col class="um">
        <col class="prezzo">
        <col class="sconto">
        <col class="totale">
        <col class="iva">
    </colgroup>

    <thead>

        <tr>

            <th>NR</th>
            <th>DESCRIZIONE</th>
            <th>QTA</th>
            <th>UNITÀ MISURA</th>
            <th>PREZZO UNITARIO</th>
            <th>SCONTO/MAGG.</th>
            <th>PREZZO TOTALE</th>
            <th>IVA</th>

        </tr>

    </thead>

    <tbody>

        ${righeHTML}

    </tbody>

</table>

<div class="section-title">

    METODO DI PAGAMENTO

</div>

<table>

    <thead>

        <tr>

            <th>MODALITÀ</th>

            <th>DECORRENZA</th>

            <th>SCADENZA</th>

            <th>IMPORTO</th>

        </tr>

    </thead>

    <tbody>

        <tr>

            <td>
                ${get("ModalitaPagamento")}
            </td>

            <td>
                ${get("Data")}
            </td>

            <td>
                ${get("DataScadenzaPagamento")}
            </td>

            <td>
                ${get("ImportoPagamento")} €
            </td>

        </tr>

    </tbody>

</table>


<div class="summary">

    <!-- REGIME FISCALE -->

    <div class="regime-fiscale">

        <div class="section-title">

            REGIME FISCALE

        </div>

        <div class="box">

            <p>

                <strong>
                    ${get("RegimeFiscale")}
                </strong>

            </p>

            <p class="small muted">

                RF19 - Operazione senza applicazione dell'IVA ai sensi dell'art.1 co. 54-89,
                della legge n. 190/2014 così come modificato dalla legge n. 208/2015 e
                dalla legge n. 145/2018

            </p>

        </div>

    </div>



    <!-- DATI AGGIUNTIVI -->

    <div class="dati-aggiuntivi">

        <div class="section-title">

            DATI AGGIUNTIVI

        </div>

        <div class="two-cols">

            <!-- DATI BOLLO -->

            <div class="box">

                <p>

                    <strong>DATI BOLLO</strong>

                </p>

                <p class="small muted">

                    Imposta di bollo assolta in modo virtuale ai sensi dell'art. 15 del
                    D.P.R. 642/1972 e del DM 17/06/2014 e ss.mm.

                </p>

            </div>



            <!-- CAUSALE DOCUMENTO -->

            <div class="box">

                <p>

                    <strong>CAUSALE DOCUMENTO</strong>

                </p>

                <p class="small muted">

                    Descrizione causale Operazione effettuata ai sensi dell'art.1 c. 54/89
                    L. 190/2014 e succ. modificazioni. Compenso non soggetto a ritenuta
                    d'acconto ai sensi dell'art.1 c. 67 L. 190/2014 e succ. modificazioni

                </p>

            </div>

        </div>

    </div>

</div>

            <div class="summary">


<div>

    <div class="section-title">

        RIEPILOGO IVA

    </div>

    <table>

        <thead>

            <tr>

                <th>IVA</th>

                <th>NATURA</th>

                <th>NORMATIVA</th>

                <th>ESIGIBILITA'</th>

                <th>IMPONIBILE</th>

                <th>IMPOSTA</th>

            </tr>

        </thead>

        <tbody>

            ${riepilogoIVAHTML}

        </tbody>

    </table>

</div>

<div>

    <div class="section-title">

        CALCOLO FATTURA

    </div>

    <div class="totals">

        <div class="totals-row">

            <span>Imponibile</span>

            <strong>
                ${fmt2(totaleImponibile)} €
            </strong>

        </div>

        <div class="totals-row">

            <span>IVA</span>

            <strong>
                ${fmt2(totaleImposta)} €
            </strong>

        </div>

        <div class="totals-row">

            <span>Arrotondamento</span>

            <strong>
                ${get("Arrotondamento") || "0.00"} €
            </strong>

        </div>

        <div class="totals-row">

            <span>Bollo</span>

            <strong>
                ${get("ImportoBollo") || "0.00"} €
            </strong>

        </div>

        <div class="totals-row">

            <span>Totale documento</span>

            <strong>
                ${get("ImportoTotaleDocumento")} €
            </strong>

        </div>

        <div class="totals-row final-total">

            <span>NETTO A PAGARE</span>

            <strong>
                ${get("ImportoPagamento")
        || get("ImportoTotaleDocumento")} €
            </strong>

        </div>

    </div>

</div>

            </div>

        </div>

    </body>

    </html>
    `;
}
